import request from '@/util/request';

//医院知识库目录树-懒加载
export const getKnowledgeProjectMenu = (params, options) =>
  request.get('/api/v4ward/knowledgeProjectMenu/lazyTree', Object.assign({}, options, { params }));
//医院知识库目录-保存
export const saveKnowledgeProjectMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectMenu/save', data, options);
//医院知识库目录-更新
export const updateKnowledgeProjectMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectMenu/update', data, options);
//医院知识库目录-删除
export const removeKnowledgeProjectMenu = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectMenu/remove', data, options);

//医院知识库文件-分页列表
export const knowledgeProjectPage = (params, options) =>
  request.get('/api/v4ward/knowledgeProjectFile/page', Object.assign({}, options, { params }));
//医院知识库文件-保存
export const saveKnowledgeProject = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectFile/save', data, options);
//医院知识库文件-删除
export const delKnowledgeProject = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectFile/remove', data, options);
//医院知识库文件-编辑详情
export const getKnowledgeProjectSelectById = (params, options) =>
  request.get('/api/v4ward/knowledgeProjectFile/selectById', Object.assign({}, options, { params }));
//医院知识库文件-更新
export const updateKnowledgeProject = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectFile/update', data, options);
//浏览量 +1
export const viewKnowledgeProject = (data, options) =>
  request.post('/api/v4ward/knowledgeProjectFile/view', data, options);
  //下载量 +1
export const projectDownload = (data, options) =>
request.post('/api/v4ward/knowledgeProjectFile/download', data, options);
//医院推荐
export const recommend = (data, options) =>
  request.post('/api/v4ward/knowledgeGroupFileRecommend/saveList', data, options);
//字典
//医院知识库文件-分页列表
export const getDictionary = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));
  export const getDept = (params, options) =>
  request.get('/api/v4ward/knowledgeGroupFile/getDept',Object.assign({}, options, { params }));
  
  export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));
